/* ------------------------------ Milky Way ------------------------------ */

export const colors = {
  blueFade: '#f3f8ff',
  blueLighter: '#a2cbff',
  blueLight: '#7091f2',
  blue: '#4e78f1',
  blueDark: '#3a66e5',
  blueDarker: '#254c93',
  coralLighter: '#fff1ea',
  coralLight: '#ff9d84',
  coral: '#ff8864',
  coralDark: '#fc7455',
  coralDarker: '#b2443e',
  tealLighter: '#b9f7e1',
  tealLight: '#39d6b4',
  teal: '#00c7af',
  tealDark: '#00a690',
  tealDarker: '#007162',
  yellowLighter: '#fffae7',
  yellowLight: '#ffd448',
  yellow: '#fdc04c',
  yellowDark: '#fdb624',
  yellowDarker: '#b17c00',
  ink: '#1c232b',
  inkLight: '#6f7881',
  inkLighter: '#a9b0b7',
  orbit: '#e2e5e7',
  spaceDarker: '#f5f5f5',
  space: '#fafafa',
  inkDisabled: 'rgba(0, 0, 0, 0.02)',
};

/* ------------------------------ Borders ------------------------------ */

export const borders = {
  borderRadiusBase: '6px',
  borderColor: colors.orbit,
};

/* ------------------------------ Box Shadow ------------------------------ */

export const boxShadow = () => {
  return {
    boxShadowColor: 'rgba(28, 35, 43, 0.15)',
    boxShadow: `0 1px 8px 0 ${this.boxShadowColor}`,
  };
};

/* ------------------------------  Navbar Globals ------------------------------ */
export const navbar = {
  navbarHeight: '72px',
  navbarHeightMobile: '60px',
  footerHeight: '70px',
};

/* ------------------------------ Typography ------------------------------ */

export const typography = {
  fontFamily: `Graphik, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif`,
  fontFamilyTitle: 'Circular Pro',
  fontSizeBase: '12px',
  fontSizeLarge: '14px',
  fontSizeSmall: '11px',
  fontSizeJumbotron: '48px',
  fontSizeH1: '32px',
  fontSizeH2: '24px',
  fontSizeH3: '20px',
  fontSizeH4: '16px',
  fontSizeH5: '14px',
  fontSizeH6: '12px',
  lineHeightComputed: '18px',
  headingsFontFamily: 'inherit',
  headingsFontWeight: '500',
  headingsLineHeight: '1.1',
};

/* ------------------------------  Media queries ------------------------------ */
export const mediaQueries = {
  breakAfterXs: 'min-width: 320px',
  breakAfterSm: 'min-width: 768px',
  breakAfterMd: 'min-width: 992px',
  breakAfterLg: 'min-width: 1200px',
  breakAfterXl: 'min-width: 1920px',
  breakBeforeXs: 'max-width: 320px',
  breakBeforeSm: 'max-width: 767px',
  breakBeforeMd: 'max-width: 991px',
  breakBeforeLg: 'max-width: 1199px',
  breakBeforeXl: 'max-width: 1919px',
};
